import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CategoryAirplaySecurityProfilePresetConfigurationEffects } from './category-airplay-security-profile-preset-configuration.effects';
import { categoryAirplaySecurityProfilePresetConfigurationReducer } from './category-airplay-security-profile-preset-configuration.reducer';

export const provideCategoryAirplaySecurityProfilePresetConfigurationStore = () => [
  provideState(
    'categoryAirplaySecurityProfilePresetConfiguration',
    categoryAirplaySecurityProfilePresetConfigurationReducer
  ),
  provideEffects([CategoryAirplaySecurityProfilePresetConfigurationEffects]),
];
